import {useEffect, useState} from 'react'

const getTimeLeft = (endDate: string) => {
  const diff = new Date(endDate).getTime() - Date.now()

  if (diff <= 0) {
    return null
  }

  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
  }
}

export const CountdownTimer = ({endDate}: {endDate: string}) => {
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(endDate))

  // Tick countdown every minute
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeLeft(endDate))
    }, 60000)

    return () => clearInterval(interval)
  }, [endDate])

  if (!timeLeft) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full border border-grey-900 px-3 py-1 text-12 text-grey-300">
        <span className="size-1.5 rounded-full bg-grey-450" />
        Ended
      </span>
    )
  }

  return (
    <span className="inline-flex shrink-0 items-center gap-1.5 text-12 text-grey-300 opacity-60">
      <span className="size-1.5 rounded-full" style={{backgroundColor: '#D18F1F'}} />
      Competition ends in{' '}
      <span className="tabular-nums" style={{color: '#D18F1F'}}>
        {timeLeft.days}d {timeLeft.hours}h
      </span>
    </span>
  )
}
